import { marked } from 'marked';

// Configure marked with safe options
marked.setOptions({
  breaks: true, // Convert \n to <br>
  gfm: true, // GitHub Flavored Markdown
  pedantic: false,
  silent: true // Don't throw on errors
});

/**
 * Parse markdown text to HTML
 * @param {string} text - The markdown text to parse
 * @returns {string} - The parsed HTML string
 */
export const parseMarkdown = (text) => {
  if (!text) return '';

  try {
    // Parse markdown to HTML
    const html = marked.parse(text);
    return html;
  } catch (error) {
    console.error('Markdown parsing error:', error);
    return text; // Return original text if parsing fails
  }
};

/**
 * Component to render markdown content safely
 * Use this to render markdown in React components
 */
export const renderMarkdown = (text) => {
  return { __html: parseMarkdown(text) };
};
